import PromoListComponent from '../../promotion/PromoListComponent';

const PomoCustomer = () => {
  return <PromoListComponent route="/customer/promotions" />;
};

export default PomoCustomer;
